import { useMemo } from 'react'

import { PERMISSIONS, ROLES } from '../../common/constants'

import {
  useLoggedInUser,
  useUserHasPermissions,
  useUserHasRoles,
} from '../../account/hooks'

const useUserHasBrandCurationTaskChangePermission = brandCurationTask => {
  const { id: currentUserId } = useLoggedInUser()

  const userCanEditAnyTask = useUserHasRoles([
    ROLES.ADMIN.value,
    ROLES.GUILD_LEAD.value,
  ])

  const hasPermissionToChangeStatusFlags = useUserHasPermissions(
    PERMISSIONS.LOCATION.UPDATE_STATUS_FLAGS,
  )

  const { assignedCurator, assignedQa, assignedQc } = brandCurationTask || {}

  const isUserCurator = useMemo(
    () => assignedCurator?.id === currentUserId,
    [assignedCurator?.id, currentUserId],
  )

  const isUserQa = useMemo(
    () => assignedQa?.id === currentUserId,
    [assignedQa?.id, currentUserId],
  )

  const isUserQc = useMemo(
    () => assignedQc?.id === currentUserId,
    [assignedQc?.id, currentUserId],
  )

  if (!hasPermissionToChangeStatusFlags) {
    return { userHasBrandChangePermission: false }
  }

  if (userCanEditAnyTask) {
    return {
      userHasBrandChangePermission: true,
      isUserCurator: true,
      isUserQa: true,
      isUserQc: true,
    }
  }

  if (isUserCurator && !brandCurationTask.isCurationDone) {
    return {
      userHasBrandChangePermission: true,
      isUserCurator: true,
      isUserQa: false,
      isUserQc: false,
    }
  }

  if (isUserQa && brandCurationTask.isCurationDone) {
    return {
      userHasBrandChangePermission: true,
      isUserCurator: false,
      isUserQa: true,
      isUserQc: false,
    }
  }

  if (isUserQc && brandCurationTask.isQaDone) {
    return {
      userHasBrandChangePermission: true,
      isUserCurator: false,
      isUserQa: false,
      isUserQc: true,
    }
  }

  return {
    userHasBrandChangePermission: false,
    isUserCurator,
    isUserQa,
    isUserQc,
  }
}

export default useUserHasBrandCurationTaskChangePermission
